import React from "react";

import CountryPage from "../components/games/CountryPage";
import NeighboursPage from "../components/games/NeighboursPage";
import CapitalPage from "../components/games/CapitalPage";
import FlagsPage from "../components/games/FlagsPage";
import SpokenLanguagesPage from "../components/games/SpokenLanguagesPage";
import PopulationPage from "../components/games/PopulationPage";
import CurrencyPage from "../components/games/CurrencyPage";
import PopulousCitiesPage from "../components/games/PopulousCitiesPage";
import AreaPage from "../components/games/AreaPage";
import { useSelector } from "react-redux";
import {
  GAME_COUNTRY,
  GAME_NEIGHBOURS,
  GAME_CAPITAL,
  GAME_FLAGS,
  GAME_SPOKEN_LANGUAGE,
  GAME_POPULATION,
  GAME_CURRENCY,
  GAME_POPULOUS_CITIES,
  GAME_AREA,
} from "../constants/gameTypes";
import GameLayout from "../components/layout/GameLayout";

const HomePage = () => {
  const { selectedGame } = useSelector(({ game }) => game);

  const gameSelector = (selectedGameKey) => {
    switch (selectedGameKey) {
      case GAME_NEIGHBOURS:
        return <NeighboursPage />;
      case GAME_CAPITAL:
        return <CapitalPage />;
      case GAME_FLAGS:
        return <FlagsPage />;
      case GAME_SPOKEN_LANGUAGE:
        return <SpokenLanguagesPage />;
      case GAME_POPULATION:
        return <PopulationPage />;
      case GAME_CURRENCY:
        return <CurrencyPage />;
      case GAME_POPULOUS_CITIES:
        return <PopulousCitiesPage />;
      case GAME_AREA:
        return <AreaPage />;
      case GAME_COUNTRY:
      default:
        return <CountryPage />;
    }
  };

  return <GameLayout>{gameSelector(selectedGame.key)}</GameLayout>;
};

export default HomePage;
